// extracted by mini-css-extract-plugin
module.exports = {"informationChip":"styles_informationChip__EyfIg","severe":"styles_severe__293aP"};